export * from './esri4-map.component';
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
